import { Routes } from "@angular/router";
import {
  COMPLETED_QUEST_ENTRY_PATH,
  COMPLETED_QUEST_PATH_PARAM,
  LIFE_PRACTICE_CUSTOM_PATH,
  LIFE_PRACTICE_DETAIL_COMPLETED_ROUTE,
  LIFE_PRACTICE_DETAIL_ROUTE_PARAM,
  QUEST_READABLE_ID_PATH_PARAM,
  COMPLETED_QUEST_ROUTE,
  COURSE_ROUTE,
  COURSE_ROUTE_PARAM,
  GROUP_PATH,
  GROUP_ROUTE_PARAM,
  INDIVIDUAL_COURSE_PATH,
  LIFE_PRACTICE_BALANCE_LP_ROUTE,
  LIFE_PRACTICE_LIST_LP_ROUTE,
  LIFE_PRACTICE_MODULE_ITEM_ID_ROUTE_PARAM,
  LIFE_PRACTICE_ROUTE,
  MODULE_SHELL_ID_PARAM,
  PROTOCOL_DETAIL_ROUTE_PARAM,
  PROTOCOL_ROUTE,
  QUEST_PATH,
  SESSION_ROUTE,
  SESSION_ROUTE_PARAM,
  SHELL_QUEST_PAGE,
  UPDATE_PROFILE,
  WEBINAR_PATH,
  WEBINAR_ROUTE_PARAM,
} from "@sdk/lib/values/shared-paths";
import { webinarPrepareResolver } from "../../webinar/webinar-prepare.resolver";

export const CONTENT_ROUTES: Routes = [
  {
    path: QUEST_PATH,
    children: [
      {
        path: `:${QUEST_READABLE_ID_PATH_PARAM}/${PROTOCOL_ROUTE}/:${PROTOCOL_DETAIL_ROUTE_PARAM}/${GROUP_PATH}/:${GROUP_ROUTE_PARAM}/${SESSION_ROUTE}/:${SESSION_ROUTE_PARAM}`,
        loadComponent: () =>
          import("../../uplift-user-quest-course/uplift-user-quest-course/uplift-user-quest-course.component").then(
            (m) => m.UpliftUserQuestCourseComponent,
          ),
      },
      {
        path: `:${QUEST_READABLE_ID_PATH_PARAM}/${PROTOCOL_ROUTE}/:${PROTOCOL_DETAIL_ROUTE_PARAM}/${INDIVIDUAL_COURSE_PATH}/${SESSION_ROUTE}/:${SESSION_ROUTE_PARAM}`,
        loadComponent: () =>
          import("../../uplift-user-quest-course/uplift-user-quest-course/uplift-user-quest-course.component").then(
            (m) => m.UpliftUserQuestCourseComponent,
          ),
      },
    ],
    title: "pageTitle.module",
  },
  {
    path: `${WEBINAR_PATH}/:${WEBINAR_ROUTE_PARAM}`,
    resolve: { webinarPrepared: webinarPrepareResolver },
    loadComponent: () =>
      import("../../webinar/webinar.component").then(
        (module) => module.WebinarComponent,
      ),
    title: "pageTitle.webinar",
  },
  {
    path: UPDATE_PROFILE,
    loadComponent: () =>
      import("../../profile-onboarding/profile-onboarding/profile-onboarding.component").then(
        (m) => m.ProfileOnboardingComponent,
      ),
    title: "pageTitle.updateProfile",
  },
  {
    path: `${COMPLETED_QUEST_ROUTE}/${COMPLETED_QUEST_ENTRY_PATH}`,
    children: [
      {
        path: `:${COMPLETED_QUEST_PATH_PARAM}`,
        loadComponent: () =>
          import("../../uplift-user-quest-result/uplift-user-quest-result/uplift-user-quest-result.component").then(
            (m) => m.UpliftUserQuestResultComponent,
          ),
      },
    ],
    title: "pageTitle.moduleHistory",
  },
  {
    path: `${SHELL_QUEST_PAGE}`,
    loadComponent: () =>
      import("../../shell-quest/shell-quest.component").then(
        (module) => module.ShellQuestComponent,
      ),
    title: "pageTitle.module",
  },
  {
    path: `${SHELL_QUEST_PAGE}/:${MODULE_SHELL_ID_PARAM}/${PROTOCOL_ROUTE}/:${PROTOCOL_DETAIL_ROUTE_PARAM}/${GROUP_PATH}/:${GROUP_ROUTE_PARAM}/${SESSION_ROUTE}/:${SESSION_ROUTE_PARAM}`,
    loadComponent: () =>
      import("../../shell-quest/shell-quest.component").then(
        (module) => module.ShellQuestComponent,
      ),
  },
  {
    path: `${SHELL_QUEST_PAGE}/:${MODULE_SHELL_ID_PARAM}/${PROTOCOL_ROUTE}/:${PROTOCOL_DETAIL_ROUTE_PARAM}/${INDIVIDUAL_COURSE_PATH}/${SESSION_ROUTE}/:${SESSION_ROUTE_PARAM}`,
    loadComponent: () =>
      import("../../shell-quest/shell-quest.component").then(
        (module) => module.ShellQuestComponent,
      ),
  },
  {
    path: LIFE_PRACTICE_ROUTE,
    children: [
      {
        path: "",
        loadComponent: () =>
          import("../../life-practice/life-practice-home/life-practice-home.component").then(
            (m) => m.LifePracticeHomeComponent,
          ),
      },
      {
        path: `${LIFE_PRACTICE_DETAIL_COMPLETED_ROUTE}/:${LIFE_PRACTICE_DETAIL_ROUTE_PARAM}`,
        loadComponent: () =>
          import("../../life-practice/life-practice-entry-detial/life-practice-entry-detail.component").then(
            (m) => m.LifePracticeEntryDetailComponent,
          ),
      },
      {
        path: `${LIFE_PRACTICE_CUSTOM_PATH}/:${LIFE_PRACTICE_DETAIL_ROUTE_PARAM}`,
        loadComponent: () =>
          import("../../life-practice/life-prcatice-detail/life-practice-detail.component").then(
            (m) => m.LifePracticeDetailComponent,
          ),
      },
    ],
    title: "pageTitle.skillPractise",
  },
  {
    path: `${LIFE_PRACTICE_ROUTE}/${GROUP_PATH}/:${GROUP_ROUTE_PARAM}/${COURSE_ROUTE}/:${COURSE_ROUTE_PARAM}/${SESSION_ROUTE}/:${SESSION_ROUTE_PARAM}/:${LIFE_PRACTICE_MODULE_ITEM_ID_ROUTE_PARAM}/${LIFE_PRACTICE_LIST_LP_ROUTE}`,
    loadComponent: () =>
      import("../../life-practice-list/life-practice-list.component").then(
        (module) => module.LifePracticeListComponent,
      ),
    title: "pageTitle.skillPractise",
  },
  {
    path: `${LIFE_PRACTICE_ROUTE}/${GROUP_PATH}/:${GROUP_ROUTE_PARAM}/${COURSE_ROUTE}/:${COURSE_ROUTE_PARAM}/${SESSION_ROUTE}/:${SESSION_ROUTE_PARAM}/:${LIFE_PRACTICE_MODULE_ITEM_ID_ROUTE_PARAM}/${LIFE_PRACTICE_BALANCE_LP_ROUTE}`,
    loadComponent: () =>
      import(
        "../../life-practice-balance/life-practice-balance.component"
      ).then((module) => module.LifePracticeBalanceComponent),
    title: "pageTitle.skillPractise",
  },
  {
    path: `${LIFE_PRACTICE_ROUTE}/${INDIVIDUAL_COURSE_PATH}/${COURSE_ROUTE}/:${COURSE_ROUTE_PARAM}/${SESSION_ROUTE}/:${SESSION_ROUTE_PARAM}/:${LIFE_PRACTICE_MODULE_ITEM_ID_ROUTE_PARAM}/${LIFE_PRACTICE_LIST_LP_ROUTE}`,
    loadComponent: () =>
      import("../../life-practice-list/life-practice-list.component").then(
        (module) => module.LifePracticeListComponent,
      ),
    title: "pageTitle.skillPractise",
  },
  {
    path: `${LIFE_PRACTICE_ROUTE}/${INDIVIDUAL_COURSE_PATH}/${COURSE_ROUTE}/:${COURSE_ROUTE_PARAM}/${SESSION_ROUTE}/:${SESSION_ROUTE_PARAM}/:${LIFE_PRACTICE_MODULE_ITEM_ID_ROUTE_PARAM}/${LIFE_PRACTICE_BALANCE_LP_ROUTE}`,
    loadComponent: () =>
      import(
        "../../life-practice-balance/life-practice-balance.component"
      ).then((module) => module.LifePracticeBalanceComponent),
    title: "pageTitle.skillPractise",
  },
];
